import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginNComponent } from './newAuthDesign/login-n/login-n.component';
import { LoginPassComponent } from './newAuthDesign/login-n/login-pass/login-pass.component';
import { ResetPasswordComponent } from './newAuthDesign/login-n/reset-password/reset-password.component';
import { AuthNComponent } from './auth-n.component';

const routes: Routes = [
	{
		path: '',
		component: AuthNComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login/otp',
				component: LoginNComponent
			},
			{
				path: 'login',
				component: LoginNComponent
			},
			{
				path: 'login/password',
				component: LoginPassComponent
			},
			{
				path: 'register',
				component: RegisterComponent
			},
			{
				path: 'forgot-password/otp',
				component: ResetPasswordComponent,
			}
			,
			{
				path: 'forgot-password',
				component: ResetPasswordComponent,
			}
			
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AuthRoutingModule { }
